import React from 'react';

import { GOAL_VISIBILITY_OPTIONS } from 'constants/ProjectConstants';
import { isMobileView } from 'constants/isMobileView';

import { SelectV2 } from 'uiToolkitV1/SelectV2';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const InitiativeVisibility = ({ visibilityType = GOAL_VISIBILITY_OPTIONS[0].value, onChange }) => {
  const selectedVisibility = GOAL_VISIBILITY_OPTIONS.find(({ value }) => value === visibilityType);

  return (
    <SelectV2
      menuItems={GOAL_VISIBILITY_OPTIONS}
      selectedItem={selectedVisibility}
      onSelect={(newValue) => onChange(newValue.value)}
      renderControlItem={
        isMobileView()
          ? (menuItem) => (
              <TextBodyMedium width="calc(50vw )" overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
                {' '}
                {menuItem?.label}{' '}
              </TextBodyMedium>
            )
          : undefined
      }
    />
  );
};
export default InitiativeVisibility;
